import api from './api';

// ─── Tipos ────────────────────────────────────────────────────────────────────

export interface Briefing {
  id: string;
  clienteId?: string | null;
  nomeEmpresa?: string | null;
  contato?: string | null;
  email?: string | null;
  status: 'PENDENTE' | 'RESPONDIDO' | 'CONCLUIDO';
  tipo?: string;
  dados?: Record<string, any> | null;
  mensagemRevisao?: string | null;
  tokenPublico?: string | null;
  createdAt: string;
  updatedAt: string;
  cliente?: {
    id: string;
    razaoSocial: string;
    nomeFantasia: string | null;
  } | null;
}

export interface BriefingCreateData {
  clienteId?: string;
  nomeEmpresa?: string;
  contato?: string;
  email?: string;
  tipo?: string;
}

// ─── Service Functions ────────────────────────────────────────────────────────

export const createBriefing = async (data: BriefingCreateData): Promise<Briefing> => {
  const response = await api.post('/briefings', data);
  return response.data;
};

export const listBriefings = async (filters?: { status?: string }): Promise<Briefing[]> => {
  const params = new URLSearchParams();
  if (filters?.status) params.append('status', filters.status);
  const response = await api.get(`/briefings?${params.toString()}`);
  return response.data;
};

export const getBriefingById = async (id: string): Promise<Briefing> => {
  const response = await api.get(`/briefings/${id}`);
  return response.data;
};

export const getBriefingByToken = async (token: string): Promise<Briefing> => {
  const response = await api.get(`/briefings/public/${token}`);
  return response.data;
};

export const responderBriefing = async (id: string, dados: Record<string, any>): Promise<Briefing> => {
  const response = await api.post(`/briefings/${id}/responder`, { dados });
  return response.data.briefing;
};

export const responderBriefingPublico = async (token: string, dados: Record<string, any>): Promise<Briefing> => {
  const response = await api.post(`/briefings/public/${token}/responder`, { dados });
  return response.data.briefing;
};

export const salvarBriefing = async (id: string, dados: Record<string, any>): Promise<Briefing> => {
  const response = await api.post(`/briefings/${id}/salvar`, { dados });
  return response.data.briefing;
};

export const salvarBriefingPublico = async (token: string, dados: Record<string, any>): Promise<Briefing> => {
  const response = await api.post(`/briefings/public/${token}/salvar`, { dados });
  return response.data.briefing;
};

export const devolverBriefing = async (id: string, mensagem: string): Promise<Briefing> => {
  const response = await api.post(`/briefings/${id}/devolver`, { mensagem });
  return response.data.briefing;
};

export const converterProspect = async (id: string): Promise<{ id: string; codigo: string }> => {
  const response = await api.post(`/briefings/${id}/converter-prospect`);
  return response.data.ticket;
};

export const converterCliente = async (id: string): Promise<{ id: string; codigo: string }> => {
  const response = await api.post(`/briefings/${id}/converter-cliente`);
  return response.data.ticket;
};

export const updateBriefing = async (id: string, data: { status?: string }): Promise<Briefing> => {
  const response = await api.patch(`/briefings/${id}`, data);
  return response.data;
};

export const deleteBriefing = async (id: string): Promise<void> => {
  await api.delete(`/briefings/${id}`);
};

// ─── Export do Service como Objeto ────────────────────────────────────────────

export const briefingService = {
  create: createBriefing,
  list: listBriefings,
  getById: getBriefingById,
  getByToken: getBriefingByToken,
  responder: responderBriefing,
  responderPublico: responderBriefingPublico,
  salvar: salvarBriefing,
  salvarPublico: salvarBriefingPublico,
  devolver: devolverBriefing,
  converterProspect,
  converterCliente,
  update: updateBriefing,
  delete: deleteBriefing,
};
